// Libraries
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { StyledClone, StyledMenuItem } from 'Components/menu/components/MenuItem/styled';
import Tippy from 'Components/flowChart/components/Tippy';

// Declare type
interface IMenuItem {
	isVisible?: boolean;
	children?: React.ReactNode;
	icon?: React.ReactNode;
	disabled?: boolean;
	divider?: boolean;
	onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
	draggableId: string;
	isDraggable?: boolean;
	index: number;
	disabledTippy?: boolean;
}

const MenuItem: React.FC<IMenuItem> = (props) => {
	// Props
	const { children, icon, onClick, draggableId, index, isDraggable, disabled = false, disabledTippy } = props;

	// Function to update style draggable item
	const getStyle = (style: React.CSSProperties, snapshot) => {
		if (!snapshot.isDropAnimating) {
			return style;
		}

		return {
			...style,
			transitionDuration: '0.0001s',
		};
	};

	return (
		<Draggable draggableId={draggableId} index={index} isDragDisabled={!isDraggable || disabled}>
			{(provided, snapshot) => {
				return (
					<>
						<Tippy arrow content={children} disabled={disabledTippy}>
							<StyledMenuItem
								isDisabled={disabled}
								ref={provided.innerRef}
								{...provided.draggableProps}
								{...provided.dragHandleProps}
								style={getStyle(provided.draggableProps.style as React.CSSProperties, snapshot)}
								className={snapshot.isDragging ? 'drag-menu-item' : ''}
								isDragging={snapshot.isDragging}
								onClick={onClick}
							>
								{icon ? <div className="wrapper-icon">{icon}</div> : null}
								<p className="content-menu-item">{children}</p>
							</StyledMenuItem>
						</Tippy>
						{snapshot.isDragging && (
							<StyledClone>
								{icon ? <div className="wrapper-icon">{icon}</div> : null}
								<p className="content-menu-item">{children}</p>
							</StyledClone>
						)}
					</>
				);
			}}
		</Draggable>
	);
};

MenuItem.defaultProps = {
	draggableId: 'drag-item',
	isDraggable: false,
	divider: false,
	index: 0,
	children: null,
	icon: null,
	onClick: () => {},
	disabledTippy: false,
};

export default MenuItem;
